module.exports = __webpack_public_path__ + "img/preopInter.c197a24c.svg";